import { ButtonSelectControlContentPlaceholder } from '../ButtonSelectControlContentPlaceholder'
import { useSelectContext } from '../Select.hooks'
import { SelectControlEntityValueItem } from '../SelectControlEntityValueItem'

import * as styles from './ButtonSelectControlContent.module.css'

function ButtonSelectControlContent({
  Placeholder = ButtonSelectControlContentPlaceholder,
  ValueItem = SelectControlEntityValueItem,
  className = styles.ButtonSelectControlContent,
  placeholderProps,
  valueItemProps,
}) {
  const { blocked, disabled, value } = useSelectContext()

  return (
    <div className={className}>
      {ValueItem && value ? (
        <ValueItem
          {...valueItemProps}
          blocked={blocked}
          disabled={disabled}
          value={value}
        />
      ) : Placeholder ? (
        <Placeholder {...placeholderProps} value={value} />
      ) : null}
    </div>
  )
}

export default ButtonSelectControlContent
